import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import classNames from 'classnames';
import './NumberItem.scss';

export default function NumberItem(props) {
  return (
    <div className={classNames(`number-item`, props.className)}>
      <Row>
        <Col>
          <div className="number-item-heading d-flex align-items-center text-green">
            <div className="number-item-count text-center">{props.number}</div>
            <div className="number-item-title">{props.title}</div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>{props.children}</p>
        </Col>
      </Row>
    </div>
  );
}
